/**
 * Auth reducer:
 * user
 *
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 15.04.2016.
 */
import {PendingState, SuccessState, ErrorState} from '../../utils'
import tv2zAnalyticsInstance from '../../services/tv2z';

import _get from 'lodash/get';

import {
  LOG_IN,
  LOG_OUT,
  REGISTRATION,
  FORGET_PASSWORD_REQ,
  FORGOTTEN_PASSWORD_CHANGE,
  REGISTRATION_CONFIRM,
  PASSWORD_CHANGE
} from '../../actions/auth/actions-auth';

import {
  GET_METADATA,
  GET_METADATA_ON_LOGIN
} from '../../actions/common/actions-common';

import Cookies from 'js-cookie';
import Config from '../../config';

const INIT_STATE = {
  user: Cookies.getJSON('v2_' + Config.operator_ext_id) || {
    user: 'guest',
    token: null,
    data: null
  },
  auth: {
    inProgress: false,
    isError: false,
    errorMsg: ''
  },
  registration: {
    needConfirmation: false,
    inProgress: false,
    isError: false,
    errorMsg: ''
  },
  registration_ack: {
    inProgress: false,
    isError: false,
    isSuccess: false,
    errorMsg: ''
  },
  forgot: {
    inProgress: false,
    isSuccess: false,
    isError: false,
    errorMsg: ''
  },
  reset: {
    inProgress: false,
    isError: false,
    isSuccess: false,
    errorMsg: ''
  },
  change_password: {
    inProgress: false,
    isError: false,
    isSuccess: false,
    errorMsg: ''
  }
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {
    case PendingState(LOG_IN):
      return {
        ...state,
        auth: {...state.auth, inProgress: true, isError: false},
        forgot: {...state.forgot, isError: false, isSuccess: false}
      };

    case SuccessState(LOG_IN):
      return {...state, user: action.payload, auth: {...state.auth, inProgress: false, isError: false}};

    case ErrorState(LOG_IN):
      return {...state, auth: {...state.auth, isError: true, inProgress: false, errorMsg: action.payload.message}};

    case PendingState(REGISTRATION):
      return {
        ...state,
        registration: {...state.registration, inProgress: true, isError: false, errorMsg: '', needConfirmation: false}
      };

    case SuccessState(REGISTRATION):
      return {
        ...state, user: action.payload,
        registration: {
          ...state.registration,
          inProgress: false,
          isError: false,
          needConfirmation: !!action.payload.needConfirmation
        }
      };

    case ErrorState(REGISTRATION):
      return {
        ...state,
        registration: {...state.registration, inProgress: false, isError: true, errorMsg: action.payload.message}
      };

    case PendingState(FORGET_PASSWORD_REQ):
      return {
        ...state,
        auth: {...state.auth, isError: false},
        forgot: {...state.forgot, inProgress: true, isSuccess: false, isError: false, errorMsg: ''}
      };

    case SuccessState(FORGET_PASSWORD_REQ):

      return {
        ...state, forgot: {...state.forgot, inProgress: false, isSuccess: true, isError: false, errorMsg: ''}
      };

    case ErrorState(FORGET_PASSWORD_REQ):
      return {
        ...state,
        forgot: {...state.forgot, inProgress: false, isError: true, isSuccess: false, errorMsg: action.payload.message}
      };

    case PendingState(FORGOTTEN_PASSWORD_CHANGE):
      return {
        ...state, reset: {...state.reset, inProgress: true, isSuccess: false, isError: false, errorMsg: ''}
      };

    case SuccessState(FORGOTTEN_PASSWORD_CHANGE):
      return {
        ...state, reset: {...state.reset, inProgress: false, isSuccess: true, isError: false, errorMsg: ''}
      };

    case ErrorState(FORGOTTEN_PASSWORD_CHANGE):
      return {
        ...state,
        reset: {...state.reset, inProgress: false, isError: true, isSuccess: false, errorMsg: action.payload.message}
      };

    case PendingState(REGISTRATION_CONFIRM):
      return {
        ...state,
        registration_ack: {...state.registration_ack, inProgress: true, isSuccess: false, isError: false, errorMsg: ''}
      };

    case SuccessState(REGISTRATION_CONFIRM):
      return {
        ...state,
        user: action.payload,
        registration_ack: {...state.registration_ack, inProgress: false, isSuccess: true, isError: false, errorMsg: ''}
      };

    case ErrorState(REGISTRATION_CONFIRM):
      return {
        ...state,
        registration_ack: {
          ...state.registration_ack,
          inProgress: false,
          isError: true,
          isSuccess: false,
          errorMsg: action.payload.message
        }
      };

    case PendingState(PASSWORD_CHANGE):
      return {
        ...state,
        change_password: {...state.change_password, inProgress: true, isSuccess: false, isError: false, errorMsg: ''}
      };

    case SuccessState(PASSWORD_CHANGE):
      return {
        ...state,
        change_password: {...state.change_password, inProgress: false, isSuccess: true, isError: false, errorMsg: ''}
      };

    case ErrorState(PASSWORD_CHANGE):
      return {
        ...state,
        change_password: {
          ...state.change_password,
          inProgress: false,
          isError: true,
          isSuccess: false,
          errorMsg: action.payload.message
        }
      };

    case PendingState(LOG_OUT):
      return {...state, auth: {...state.auth, inProgress: true}};

    case SuccessState(LOG_OUT):
      return {
        ...state, user: {
          user: 'guest',
          token: null
        }, auth: {...state.auth, inProgress: false, isError: false}
      };

    case SuccessState(GET_METADATA_ON_LOGIN):
      if (_get(Config, 'analytics.tv2z', false) && action.payload[6]) {
        tv2zAnalyticsInstance.setUser(_get(action, 'payload[6].user.id'));
      }

      return {
        ...state,
        user: {
          ...state.user,
          data: action.payload[6] && action.payload[6].user || null
        }
      };

    case SuccessState(GET_METADATA):
      if (_get(Config, 'analytics.tv2z', false) && action.payload[6]) {
        tv2zAnalyticsInstance.setUser(_get(action, 'payload[6].user.id'));
      }

      return {
        ...state,
        user: {
          ...state.user,
          data: action.payload[6] && action.payload[6].user || null
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth/reducer-auth.js